<template>
  <div class="navigation-button" :class="{ active: isCurrentRoute }">
    <div class="icon-chip">
      <span class="mdi" :class="iconClass" aria-hidden="true" />
    </div>
    <div class="copy">{{ title }}</div>
    <div class="line-container" aria-hidden="true">
      <div class="line primary" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationButton',
  props: {
    title: String,
    icon: String,
    routeName: String,
  },
  computed: {
    isCurrentRoute() {
      return this.$route.name === this.routeName;
    },
    iconClass() {
      if (!this.icon) {
        return '';
      }
      return this.icon.startsWith('mdi-') ? this.icon : `mdi-${this.icon}`;
    },
  },
};
</script>

<style scoped lang="scss">
.navigation-button {
  width: 100%;
  min-height: 44px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 10px 4px 12px;
  border: none;
  background: transparent;
  transition: background-color 150ms ease;

  &.active {
    background-color: rgba($general-white, 0.14);

    .line-container .line {
      height: 70%;
    }

    .icon-chip {
      background-color: rgba($general-white, 0.24);
      box-shadow: 0 0 0 1px rgba($general-white, 0.2);
    }

    .copy {
      opacity: 1;
      font-weight: 600;
    }
  }

  &:hover {
    background-color: rgba($general-white, 0.08);

    .copy {
      opacity: 1;
    }

    .icon-chip {
      background-color: rgba($general-white, 0.18);
    }
  }

  .icon-chip {
    width: 36px;
    height: 36px;
    min-width: 36px;
    border-radius: 10px;
    background-color: rgba($general-white, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 150ms ease, box-shadow 150ms ease;

    .mdi {
      font-size: 20px;
      line-height: 1;
      color: $general-white;
    }
  }

  .copy {
    flex: 1;
    min-width: 0;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.25;
    color: $general-white;
    opacity: 0.88;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .line-container {
    width: 4px;
    height: 100%;
    right: 0;
    top: 0;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;

    .line {
      width: 4px;
      height: 0%;
      position: relative;
      background-color: $general-white;
      border-radius: 4px 0 0 4px;
      transition: height 150ms ease-in-out;
    }
  }
}
</style>
